import type { SelectValueChangeDetails } from "@ark-ui/solid";
import { CreditCard } from "lucide-solid";
import { type Component, Match, Show, Switch } from "solid-js";
import { StyledSelect } from "~/solidJs/shared/ui/molecules/Select";
import type { PaymentCurrency, PaymentMethod } from "../model";

type PaymentSelectorProps = {
	selectedPaymentMethod: PaymentMethod[];
	paymentMethods: PaymentMethod[];
	onChange?: (paymentMethod: SelectValueChangeDetails<PaymentMethod>) => void;
	onClick?: () => void;
};

export const PaymentSelector: Component<PaymentSelectorProps> = (props) => {
	return (
		<StyledSelect.SelectClosedComponent
			rootProps={{
				multiple: false,
				onValueChange: props.onChange,
				class: "shrink-0",
				onOpenChange: (details) => {
					if (details.open) {
						props.onClick?.();
					}
				}
			}}
			renderValue={() => (
				<>
					<Show when={!props.selectedPaymentMethod.length}>
						<span class="typography-text-14-medium whitespace-nowrap text-text-secondary">
							Select payment method
						</span>
					</Show>
					<Show when={props.selectedPaymentMethod[0]} keyed>
						{(selectedPaymentMethod) => (
							<div class="flex shrink-0 items-center gap-1.5 text-text-primary">
								<CreditCard size={16} />
								<span class="typography-text-14-medium">
									{selectedPaymentMethod.label}
								</span>
							</div>
						)}
					</Show>
				</>
			)}
			value={props.selectedPaymentMethod}
			items={props.paymentMethods}
		/>
	);
};

type CurrencySelectorProps = {
	selectedCurrency: PaymentCurrency;
	currencies: PaymentCurrency[];
	onChange: (currency: PaymentCurrency) => void;
	readonly?: boolean;
	contentClass?: string;
	hideLabel?: boolean;
};

export const CurrencySelector: Component<CurrencySelectorProps> = (props) => {
	return (
		<div class="flex items-center gap-1">
			<Show when={!props.hideLabel}>
				<span class="typography-text-14-medium text-text-secondary-v2">Pay in</span>
			</Show>
			<Switch>
				<Match when={!props.readonly}>
					<StyledSelect.SelectClosedComponent
						rootProps={{
							multiple: false,
							onValueChange(d) {
								const selected = d.items[0];
								if (!selected) return;
								props.onChange(selected);
							}
						}}
						contentProps={{ class: props.contentClass || "w-40" }}
						value={props.currencies.filter(
							(item) => item.value === props.selectedCurrency.value
						)}
						items={props.currencies}
					/>
				</Match>
				<Match when={props.readonly}>
					<span class="typography-text-14-medium flex items-center justify-center gap-1.5 px-2 py-1 text-text-primary">
						{
							props.currencies.find(
								(item) => item.value === props.selectedCurrency.value
							)?.label
						}
					</span>
				</Match>
			</Switch>
		</div>
	);
};
